import Timeline from '@core/components/Timeline';
import { Grid, makeStyles } from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { FaArrowCircleUp, FaFileContract } from 'react-icons/fa';

export const styles = makeStyles({
  icone: {
    backgroundColor: '#919191',
  },
});

const HistoricoContratoVisualizacao = ({ historico }) => {
  const tipoCampo = {
    DATA_VENCIMENTO_RECEITA: 'a data de vencimento',
    DIA_VENCIMENTO: 'Vencimento da cobrança',
    VALOR: 'Valor',
    VALOR_RECEITA: 'o valor',
    VIGENCIA_INICIAL: 'Vigência inicial',
    VIGENCIA_FINAL: 'Vigência final',
    FORMA_RECEBIMENTO: 'Forma de recebimento',
  };

  const classes = styles();

  const getSubtitulo = (registro) => {
    return moment(registro.dataHora).format('HH:mm [do dia] DD/MM/YYYY');
  };

  const getIcone = (registro) => {
    if (registro.origem === 'CONTRATO') {
      return <FaFileContract size={20} style={{ backgroundColor: '#919191' }} />;
    }
    if (registro.origem === 'CONTA_RECEBER') {
      return (
        <div style={{ margin: '-10px', backgroundColor: '#fff' }}>
          <FaArrowCircleUp size={30} color="#919191" />
        </div>
      );
    }

    return '';
  };

  const getDescricao = (registro) => {
    if (registro.origem === 'CONTRATO' && !!registro.nomeUsuario) {
      return `${registro.nomeUsuario} alterou o campo ${tipoCampo[registro.nomeCampo]} de "${
        registro.valorAnterior
      }" para "${registro.valorAtual}" na edição do contrato.`;
    }
    if (registro.origem === 'CONTRATO' && !registro.nomeUsuario && registro.nomeCampo === 'VALOR') {
      return `O contrato teve o valor reajustado automaticamente de "${registro.valorAnterior}" para "${registro.valorAtual}".`;
    }
    if (registro.origem === 'CONTA_RECEBER') {
      return `${registro.nomeUsuario} alterou ${
        tipoCampo[`${registro.nomeCampo}_RECEITA`]
      } da cobrança da competência ${registro.competencia} de "${registro.valorAnterior}" para "${
        registro.valorAtual
      }" na edição da conta a receber.`;
    }

    return '';
  };

  return (
    <Grid container spacing={3}>
      <Timeline
        registros={historico}
        pageSize={3}
        getIcone={getIcone}
        getSubtitulo={getSubtitulo}
        getDescricao={getDescricao}
        iconeStyles={classes.icone}
      />
    </Grid>
  );
};

export default HistoricoContratoVisualizacao;
